module.exports = __webpack_public_path__ + "img/77e57ef.jpg";